/* 
 * React component to show the left sidebar in the admin interface.
 */

import  TemplateSelector                from '../Template/TemplateSelector'
import  TeamSelector                    from '../Team/TeamSelector'
import  AppTypeSelectList               from '../AppointmentType/AppTypeSelectList'
import  BookingSideBarTasks             from '../Booking/BookingSideBarTasks';      
import  SideBarTopButtons               from './SideBarTopButtons';
import  {TwoSwitch}                     from '../../lib/iprs-react-library/src/index.js';
import userLoggedInHasRole              from '../Util/userLoggedInHasRole';


const SideBar = ({api, eventDispatch, state}) => {

    const hasDiaryRotaPerm = userLoggedInHasRole(api, 'Diary Rota');
    
    return (
        <div className='leftNav'>

            <div>
                <SideBarTopButtons eventDispatch={eventDispatch} state={state} /> 
            </div>
            <div>
                <BookingSideBarTasks eventDispatch={eventDispatch} 
                    state={state} />
            </div>
            
            <h2>Teams</h2>
            <div style={{maxHeight: '30vh', overflowY: 'auto', marginBottom: '1em'}}>
                <TeamSelector api={api} eventDispatch={eventDispatch} 
                    state={state} />
            </div>
               
            <h2>Appointment Types</h2>
            <div style={{ maxHeight: '30vh', minHeight: '5vh', overflowY: 'auto' }}>
                <AppTypeSelectList api={api} eventDispatch={eventDispatch}
                    state={state} />
            </div>
                        
            <h2>Templates</h2>
            <TwoSwitch test={hasDiaryRotaPerm} >
                <TemplateSelector api={api} eventDispatch={eventDispatch} 
                    state={state} />
                <p>You don't have permission to use templates.</p>
            </TwoSwitch>
        </div>
    )
}

export default SideBar




